<template>
  <div id="kt_footer" class="footer bg-white py-4 d-flex flex-lg-column">
    <!--begin::Container-->
    <div
      class="d-flex flex-column text-center mx-auto flex-md-row align-items-center justify-content-between"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <!--begin::Copyright-->
      <div class="text-dark mx-auto text-center order-2 order-md-1">
        <span class="text-muted font-weight-bold mr-2">۱۴۰۱©</span>
        کلیه حقوق مادی و معنوی این سامانه محفوظ و متعلق به شرکت تبلیغاتی
        <a
          href="https://karafarinanebartar.com"
          target="_blank"
          class="text-dark-75 text-hover-primary"
          > کارآفرینان برتر</a
        >
        سپهر آراد می باشد ، هرگونه کپی برداری پیگرد قانونی دارد.
      </div>
      <!--end::Copyright-->
      <!--begin::Nav-->
      <div class="nav nav-dark order-1 order-md-2">
        <a v-for="(item, i) in footerLinks"

           :href="item.link"
           target="_blank"
           class="nav-link pr-3 pl-0"
        >
          {{item.name}}


        </a>
<!--        <a-->
<!--          href="https://payamakland.com/"-->
<!--          target="_blank"-->
<!--          class="nav-link pr-3 pl-0"-->
<!--          >پیامک لند</a-->
<!--        >-->
<!--        <a-->
<!--          href="https://robatland.com/"-->
<!--          target="_blank"-->
<!--          class="nav-link px-3"-->
<!--          >ربات لند</a-->
<!--        >-->
<!--        <a-->
<!--          target="_blank"-->
<!--          class="nav-link px-3"-->
<!--          >کیو آر لند</a-->
<!--        >-->
      </div>
      <!--end::Nav-->
    </div>
    <!--end::Container-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
    footerLinks() {
      return this.layoutConfig("footer.links");
    }


  }
};
</script>
